// Test IDs for new features: product detail, account (orders/kundlis/bookings),
// consultations booking, panchang widget, and store search/filter.

export const STORE_FILTER = {
  searchInput: 'store-search-input',
  categoryChip: (cat) => `store-category-${cat.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`,
  clearFilters: 'store-clear-filters',
};

export const PRODUCT_DETAIL = {
  page: 'product-detail-page',
  addToCartBtn: 'product-detail-add-to-cart',
  qtyDec: 'product-detail-qty-dec',
  qtyInc: 'product-detail-qty-inc',
};

export const ACCOUNT = {
  page: 'account-page',
  tabOrders: 'account-tab-orders',
  tabKundlis: 'account-tab-kundlis',
  tabBookings: 'account-tab-bookings',
  ordersList: 'account-orders-list',
  kundlisList: 'account-kundlis-list',
  bookingsList: 'account-bookings-list',
  deleteKundli: (id) => `account-kundli-delete-${id}`,
  accountLink: 'nav-account-link',
  trackOrderBtn: (sid) => `account-track-order-${sid}`,
  rescheduleBtn: (sid) => `account-reschedule-${sid}`,
  cancelBookingBtn: (sid) => `account-cancel-booking-${sid}`,
  rescheduleDate: 'account-reschedule-date',
  rescheduleTime: 'account-reschedule-time',
  rescheduleConfirm: 'account-reschedule-confirm',
};

export const TRACKING = {
  page: 'order-tracking-page',
  stage: (index) => `tracking-stage-${index}`,
  trackingNumber: 'tracking-number',
  estimatedDelivery: 'tracking-estimated-delivery',
};

export const CONSULT = {
  page: 'consult-page',
  astrologerCard: (id) => `consult-astrologer-${id}`,
  bookBtn: (id) => `consult-book-${id}`,
  slotDate: 'consult-slot-date',
  slotTime: 'consult-slot-time',
  nameInput: 'consult-name-input',
  questionInput: 'consult-question-input',
  confirmBtn: 'consult-confirm-btn',
};

export const PANCHANG = {
  widget: 'panchang-widget',
  content: 'panchang-content',
};

export const KUNDLI = {
  saveBtn: 'predictions-kundli-save-btn',
};
